import { cn as e } from "../../../shared/utils.js";
import { Button as t } from "../../../button/primitive/button.js";
import { useTranslation as n } from "../../../i18n/hooks.js";
import { XCloseIcon as r } from "@systemeio/icons";
import { jsx as i } from "react/jsx-runtime";
import { Dialog as a } from "@base-ui/react/dialog";
//#region src/table/bulk-actions/primitive/bulk-actions.tsx
var o = ({ disablePointerDismissal: e = !0, ...t }) => /* @__PURE__ */ i(a.Root, {
	modal: !1,
	disablePointerDismissal: e,
	...t
}), s = a.Portal, c = ({ className: t, ...n }) => /* @__PURE__ */ i(a.Popup, {
	className: e("bg-bg-primary fixed flex items-center transition-[opacity,translate,scale] duration-200 ease-in-out will-change-transform", "data-ending-style:translate-y-2 data-ending-style:scale-[0.98] data-ending-style:opacity-0", "data-starting-style:translate-y-2 data-starting-style:scale-[0.98] data-starting-style:opacity-0", "border-border-100 bottom-0 left-0 w-full gap-2 border-t p-4", "desktop:border-border-accent tablet:w-full desktop:inset-x-1 desktop:bottom-6 desktop:mx-auto desktop:min-h-15 desktop:w-[calc(100%-2rem)] desktop:max-w-3xl desktop:gap-3 desktop:rounded-xl desktop:border desktop:px-4 desktop:py-3.5", t),
	...n
});
c.displayName = "BulkActions.Popup";
var l = (e) => {
	let { t: o } = n();
	return /* @__PURE__ */ i(a.Close, {
		render: (e) => /* @__PURE__ */ i(t, {
			variant: "ghost-gray",
			size: "icon-sm",
			"aria-label": o("public_pages_purchase.table.bulk_actions.close"),
			...e,
			children: e.children ?? /* @__PURE__ */ i(r, {})
		}),
		...e
	});
};
l.displayName = "BulkActions.Close";
var u = (t) => /* @__PURE__ */ i("div", {
	role: "separator",
	"aria-orientation": "vertical",
	...t,
	className: e("bg-border-100 h-6 w-px shrink-0", t.className)
});
u.displayName = "BulkActions.Separator";
var d;
(function(e) {
	e.Root = o, e.Portal = s, e.Popup = c, e.Close = l, e.Separator = u;
})(d ||= {});
//#endregion
export { d as BulkActions };
